import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import {
  AuctionApplication,
  ChatButton,
  withApplicationContext,
} from '@adc/ui-adc'
import configment from '@adc/configment'
import { standardSchemas } from '@adc/analytics'
import '@adc/ui-adc/lib/styles.css'
import analytics from '../services/event.analytics'
import types from '../constants/event.propTypes'
import STATICS from '../event.statics'
import auctionSmartAppImg from '../assets/auction_smart_banner_logo.svg'
import '../scss/event.base.scss'
import { fetchDataForNewlyAuthenticatedUser } from '../actions/event.user'
import EventDetails from './eventDetails'

const AuctionApp = ({
  featureFlags,
  event,
  user,
  onAuthenticationComplete,
  ssrHints,
}) => {
  useEffect(() => {
    analytics.trackPageLoad(user, event, featureFlags)
  }, [event, user, featureFlags])

  const ADC_LOGO = configment.get('AUCTIONCOM_LOGO_URL', '')
  const ADC_EVENT_CALENDAR_BREADCRUMB = {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': `https://www.auction.com`,
          name: 'Auction.com',
        },
      },
    ],
  }
  const headerDataStructure = [
    standardSchemas.corporateSchema(ADC_LOGO),
    standardSchemas.searchSiteSchema(),
    standardSchemas.organizationSchema(ADC_LOGO),
    standardSchemas.webPageSchema(
      'https://www.auction.com/event/details',
      event.__computed__.page_title,
      STATICS.PAGE_DESCRIPTION,
      ADC_EVENT_CALENDAR_BREADCRUMB,
      ['real estate auction', 'residential auction', 'auction event']
    ),
  ]

  const helmetConfig = {
    title: event.__computed__.page_title,
    description: STATICS.PAGE_DESCRIPTION,
    children: (
      <script type='application/ld+json'>
        {JSON.stringify(headerDataStructure)}
      </script>
    ),
  }
  const isNewNavigationEnabled = featureFlags['fe.resi.enable-new-navigation']

  const headerProps = {
    loadGoogleMaps: true,
    user,
    redirectOnSelected: true,
    showLiveChat: true,
    featureFlags,
    ...(isNewNavigationEnabled && {
      enableNewMobileHeader: true,
      newMobileHeaderLogoVariant: 'icon',
    }),
  }

  const capabilities = useMemo(() => {
    return {
      authentication: {
        enabled: true,
        options: {
          onAuthenticationComplete,
        },
      },
    }
  }, [onAuthenticationComplete])

  return (
    <AuctionApplication
      sspConfig={configment.get()}
      user={user}
      helmetConfig={helmetConfig}
      headerProps={headerProps}
      featureFlags={featureFlags}
      capabilities={capabilities}
      ssrHints={ssrHints}
    >
      <Helmet
        link={[
          { rel: 'android-touch-icon', href: auctionSmartAppImg },
          { rel: 'apple-touch-icon', href: auctionSmartAppImg },
        ]}
      />
      <EventDetails />
      <ChatButton />
    </AuctionApplication>
  )
}

AuctionApp.propTypes = {
  featureFlags: types.featureFlags.isRequired,
  event: PropTypes.object.isRequired,
  user: types.user.isRequired,
  onAuthenticationComplete: PropTypes.func.isRequired,
  ssrHints: PropTypes.object,
}

const mapStateToProps = store => ({
  featureFlags: store.featureFlags,
  event: store.event.event,
  user: store.user,
})

const mapDispatchToProps = dispatch => ({
  // AuthModal required capabilites
  onAuthenticationComplete: user =>
    dispatch(fetchDataForNewlyAuthenticatedUser(user)),
})

export default withApplicationContext(
  connect(mapStateToProps, mapDispatchToProps)(AuctionApp)
)
